<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    scrollable
    :fullscreen="$vuetify.display.xs"
    style="z-index: 1100 !important;"
  >
    <v-card v-cloak data-cy="dialog-apiHelp-modal">
      <v-card-title class="d-flex justify-space-between" data-cy="dialog-apiHelp-title">
        <span>
          <v-icon class="mr-2">mdi-help-circle</v-icon>
          {{ $t('routes.apiClients.helpTitle') }}
        </span>
        <v-btn icon variant="text" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <div class="mb-4">
          <div class="text-subtitle-1 font-weight-bold mb-2">{{ $t('routes.apiClients.clientId') }}</div>
          <p class="text-body-2">{{ $t('routes.apiClients.helpClientIdDescription') }}</p>
        </div>

        <div class="mb-4">
          <div class="text-subtitle-1 font-weight-bold mb-2">{{ $t('routes.apiClients.clientSecret') }}</div>
          <p class="text-body-2">{{ $t('routes.apiClients.helpClientSecretDescription') }}</p>
        </div>

        <div class="mb-4">
          <div class="text-subtitle-1 font-weight-bold mb-2">{{ $t('routes.apiClients.user') }}</div>
          <p class="text-body-2">{{ $t('routes.apiClients.helpUserDescription') }}</p>
        </div>

        <v-divider class="my-4" />

        <div class="text-subtitle-1 font-weight-bold mb-3">{{ $t('routes.apiClients.documentationLinks') }}</div>

        <div class="d-flex flex-column gap-2">
          <a
            href="https://api.tubeway.io/v2/docs/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary d-flex align-center"
            data-cy="dialog-apiHelp-apiDocs"
          >
            <v-icon size="small" class="mr-2">mdi-file-document-outline</v-icon>
            {{ $t('routes.apiClients.apiDocsLabel') }}
            <v-icon size="small" class="ml-1">mdi-open-in-new</v-icon>
          </a>

          <a
            href="https://auth.tubeway.io/v1/docs"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary d-flex align-center"
            data-cy="dialog-apiHelp-authDocs"
          >
            <v-icon size="small" class="mr-2">mdi-shield-key-outline</v-icon>
            {{ $t('routes.apiClients.authDocsLabel') }}
            <v-icon size="small" class="ml-1">mdi-open-in-new</v-icon>
          </a>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="bg-primary"
          elevation="0"
          @click="dialog = false"
          data-cy="dialog-apiHelp-close"
        >
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HelpDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>
